<template>
  <li role="presentation">
    <p class="b-dropdown-text">
      <slot />
    </p>
  </li>
</template>

<script>
export default {
  name: 'BDropdownText'
}
</script>
